/* eslint-disable max-len */
import { leadTrailTrim, trimValue } from '../trim';

/** 中文汉字 占位符 */
const chineseCharSymbol = '#chinese#';

/** 地址敏感字符 */
const addressSensitive = ['国家安全局', '国安局'];

/** 中文汉字 正则匹配符 */
const chineseCharReg = '\\u2e80-\\u2eff\\u2f00-\\u2fdf\\u31c0-\\u31ef\\u3200-\\u32ff\\u3300-\\u33ff\\u3400-\\u4dbf\\u4dc0-\\u4dff\\u4e00-\\u9fbf\\uf900-\\ufaff\\ufe30-\\ufe4f';

/**
 * 生成包含中文汉字的正则(兼容生僻字)
 * @param regExpStr 正则字符串,如：^[#chinese#-0-9-a-zA-Z]{5,50}$`
 * @returns 正则对象
 */
const createIncludeChineseRegExp = (regExpStr: string) => {
  try {
    return new RegExp(regExpStr.replace(new RegExp(chineseCharSymbol, 'g'), chineseCharReg));
  } catch (err) {
    return new RegExp('^$');
  }
};

/** 详细地址5-50字(允许空格) */
export const detailAddressLengthRegExp = createIncludeChineseRegExp('^.{5,50}$');

/** 详细地址5-50字(含生僻字)校验(允许空格) */
export const detailAddressRegExp = createIncludeChineseRegExp(`^[${chineseCharSymbol}-0-9-a-zA-Z\\s]{5,50}$`);

/** 中文名称5+字(含生僻字)校验 */
export const companyNameRegExp = createIncludeChineseRegExp(`^[${chineseCharSymbol}]{5,}$`);

// 校验手机号或者固定电话
export const checkTelPhone = (value: string): boolean => /^(0\d{2,3}-?)?\d{5,11}$/.test(trimValue(value));

// 单位名称校验--5个汉字以上
export const checkCompanyName = (value: string): boolean => companyNameRegExp.test(trimValue(value));

// 单位详细地址校验
export const checkCompanyDetails = (value: string): boolean => detailAddressRegExp.test(leadTrailTrim(value));

// 地址长度校验
export const checkDetailAddressLength = (value: string): boolean => detailAddressLengthRegExp.test(leadTrailTrim(value));

// 检测详细地址是否包含敏感词
export const checkAddressSensitive = (value: string): boolean => !addressSensitive.some(
  (sensitiveWord) => value.includes(sensitiveWord),
);

// 邮箱校验
export const checkEmail = (value: string): boolean => /^\w+@[a-z0-9]+\.[a-z]{2,4}$/.test(trimValue(value));

/** 手机号虚拟号校验 */
export const checkVirtualNumber = (value: string): boolean => /^13\d{9}|143\d{8}|15\d{9}|16[0146]\d{8}|17[3-8]\d{8}|18\d{9}|19[134589]\d{8}$/.test(trimValue(value));

export const validarorTips = {
  addressSensitiveTip: '您输入的信息较为敏感，请更换内容',
  addressLengthTip: '详细地址长度为5-50个字',
  addressContentTip: '使用了不支持的标点及特殊符号，请调整',
};

/** 验证姓名：支持 中文字符、生僻字、“·” 且长度为 2~50 */
export function validatorPersonName(val: string): boolean {
  return createIncludeChineseRegExp(`^[${chineseCharSymbol}·]{2,50}$`).test(trimValue(val));
}
